import React, {useEffect, useState} from "react";
import {P} from "@/components/ui/P";
import CaruselService from "@/components/ui/carusel";
import {CarouselItem} from "@/components/ui/carousel";
import {AdCard} from "@/components/adsPage/AdCard";
import Link from "next/link";
import {Button} from "@/components/ui/button";
import {fetchAllActiveAdsDto} from "@/helpers/fetch-ad";
import {DTOAd} from "@/app/(site)/obyavleniya/page";
import {PATH} from "@/data/path";
import {PageData} from "@/intefaces/page.props";
interface AdsCoruselProps{
    isSellPage?:boolean
    isDots?:boolean
    isButton?:boolean
}
export const AdsCorusel = ({isSellPage, isDots = true,isButton = true}:AdsCoruselProps) => {
    const [ads, setAds] = useState<DTOAd[]>([]);

    useEffect(() => {
        async function loadAds() {
            const data = await fetchAllActiveAdsDto();
            setAds(data);
            if (data) {
                return
            }
        }

        loadAds();
    }, []);
    return (
        <>
            {ads.length > 0 && !isSellPage && (
                <div className="max-w-custom mx-auto my-14 p-3">
                    <P size="l" className="mb-3">Выгодные предложения</P>
                    <CaruselService isDots={isDots}>
                        {ads.map((ad) => (
                            <CarouselItem
                                key={ad.id}
                                className="basis-full sm:basis-1/2 lg:basis-1/3"
                            >
                                <AdCard {...ad} />
                            </CarouselItem>
                        ))}
                    </CaruselService>
                    <div className="flex w-full">
                        {isButton && <Link href="/obyavleniya" className="ml-auto">
                            <Button variant="outline" className="max-w-[400px] text-sm">
                                ВСЕ ОБЪЯВЛЕНИЯ
                            </Button>
                        </Link>
                        }
                    </div>
                </div>
            )}
        </>
    );
};
